import React from 'react';
import ResetPassword from '../../forms/RequestResetPassword';
import centredForm from '../components/centredForm';
import FormTitle from '../components/FormTitle';

export default centredForm(
  ResetPassword,
  <FormTitle title="requestResetPasswordTitle" />,
  700
);



// WEBPACK FOOTER //
// ./src/view/scenes/RequestResetPassword/index.js